import { Instance } from 'mobx-state-tree';
import { UserDtoModelBase } from './UserDtoModel.base';
import getInitials from '../utils/getInitials';

/* The TypeScript type of an instance of UserDtoModel */
export interface UserDtoModelType extends Instance<typeof UserDtoModel.Type> {}

/* A graphql query fragment builders for UserDtoModel */
export { selectFromUserDto, userDtoModelPrimitives, UserDtoModelSelector } from './UserDtoModel.base';

/**
 * UserDtoModel
 */
export const UserDtoModel = UserDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
    setVerified(verified: boolean) {
      self.verified = verified;
    },
  }))
  .views((self) => ({
    get initials(): string {
      return getInitials(self.fullname as string);
    },
  }));
